<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <div
                class="instances-docker-view-switcher"
                role="group"
                aria-label="Tipo de vista"
              >
                <b-button
                  variant="link"
                  class="list-view-icon-btn"
                  :class="{
                    'list-view-icon-btn--active': dockerViewMode == 'cards',
                  }"
                  v-b-tooltip.hover.bottom
                  title="Vista de tarjetas"
                  @click="dockerViewMode = 'cards'"
                  ><AppIcon
                    name="view_module"
                    :fill="dockerViewMode == 'cards'" /></b-button
                ><b-button
                  variant="link"
                  class="list-view-icon-btn"
                  :class="{
                    'list-view-icon-btn--active': dockerViewMode == 'tree',
                  }"
                  v-b-tooltip.hover.bottom
                  title="Vista en árbol"
                  @click="dockerViewMode = 'tree'"
                  ><AppIcon
                    name="account_tree"
                    :fill="dockerViewMode == 'tree'" /></b-button
                ><b-button
                  variant="link"
                  class="list-view-icon-btn"
                  :class="{
                    'list-view-icon-btn--active': dockerViewMode == 'full',
                  }"
                  v-b-tooltip.hover.bottom
                  title="Vista completa (todo desplegado)"
                  @click="dockerViewMode = 'full'"
                  ><AppIcon name="view_list" :fill="dockerViewMode == 'full'"
                /></b-button>
              </div>
              <b-button
                variant="link"
                class="list-view-icon-btn"
                :class="{ 'list-view-icon-btn--active': filtersOpen }"
                v-b-tooltip.hover.bottom
                :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                :aria-label="
                  filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'
                "
                @click="filtersOpen = !filtersOpen"
              >
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button
                variant="link"
                class="list-view-icon-btn list-view-icon-btn--primary"
                v-b-tooltip.hover.bottom
                title="Agregar sistema Docker"
                aria-label="Agregar sistema Docker"
                @click="add()"
              >
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div
              class="list-view-filter"
              style="flex: 1 1 240px; max-width: 340px"
            >
              <label class="filter-label">Buscar</label>
              <b-form-input
                type="text"
                size="sm"
                placeholder="Nombre o dominio"
                v-model="filters.name"
                v-on:keyup.enter.native="filter"
              />
            </div>
            <div
              class="list-view-filter"
              style="flex: 1 1 230px; max-width: 310px"
            >
              <label class="filter-label">Cliente</label>
              <v-select
                :options="arr.select.customers"
                v-model="filters.customer"
                placeholder="Todos"
                :multiple="false"
                :select-on-tab="true"
              />
            </div>
            <div
              class="list-view-filter"
              style="flex: 1 1 220px; max-width: 300px"
            >
              <label class="filter-label">Agrupación</label>
              <v-select
                :options="arr.select.categories"
                v-model="filters.categories"
                placeholder="Todas"
                :multiple="false"
                :select-on-tab="true"
              />
            </div>
            <div
              class="list-view-filter"
              style="flex: 1 1 210px; max-width: 290px"
            >
              <label class="filter-label">Servidor</label>
              <v-select
                :options="arr.select.instances_servers"
                v-model="filters.instances_server"
                placeholder="Todos"
                :multiple="false"
                :select-on-tab="true"
              />
            </div>
            <div
              class="list-view-filter"
              style="flex: 1 1 230px; max-width: 320px"
            >
              <label class="filter-label">Estado operativo</label>
              <v-select
                :options="arr.filter.health"
                v-model="filters.health"
                :clearable="false"
                :multiple="false"
                :select-on-tab="true"
              />
            </div>
            <b-button
              variant="outline-dark"
              size="sm"
              @click="filter()"
              v-b-tooltip.hover
              title="Aplicar filtros"
              style="height: 31px; width: 31px; padding: 0; flex-shrink: 0"
            >
              <AppIcon name="filter" label="Aplicar filtros" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body>
        <div
          v-if="table.isBusy"
          class="instances-docker-loader"
          role="status"
          aria-live="polite"
        >
          <b-spinner
            variant="primary"
            label="Cargando sistemas Docker"
          ></b-spinner>
          <span>Cargando sistemas Docker...</span>
        </div>
        <div v-else-if="table.items.length" class="instances-docker-groups">
          <b-card
            v-for="group in groupedDockerSystems"
            :key="group.id"
            no-body
            class="instances-docker-group-card"
          >
            <button
              type="button"
              class="instances-docker-group-card__header"
              :class="{
                'instances-docker-group-card__header--static':
                  dockerViewMode == 'full',
              }"
              @click="toggleDockerGroup(group.id)"
            >
              <span class="instances-docker-group-card__icon"
                ><AppIcon name="folder" font-scale="1.2"
              /></span>
              <div class="instances-docker-group-card__summary">
                <h3>{{ group.name }}</h3>
                <span
                  >{{ group.items.length }}
                  {{ group.items.length == 1 ? "sistema" : "sistemas" }}</span
                >
              </div>
              <div
                class="instances-docker-group-card__health"
                :aria-label="getDockerGroupHealthLabel(group.health)"
              >
                <span
                  v-if="group.health.withoutBackups"
                  class="instances-docker-group-card__health-item instances-docker-group-card__health-item--warning"
                  v-b-tooltip.hover
                  :title="
                    group.health.withoutBackups +
                    ' sistema(s) sin backups activos'
                  "
                >
                  <AppIcon name="backup" />
                  {{ group.health.withoutBackups }} sin backups
                </span>
                <span
                  v-if="group.health.accessProblems"
                  class="instances-docker-group-card__health-item instances-docker-group-card__health-item--danger"
                  v-b-tooltip.hover
                  :title="
                    group.health.accessProblems +
                    ' sistema(s) con problemas de acceso'
                  "
                >
                  <AppIcon name="link_off" />
                  {{ group.health.accessProblems }} acceso
                </span>
                <span
                  v-if="group.health.dnsProblems"
                  class="instances-docker-group-card__health-item instances-docker-group-card__health-item--danger"
                  v-b-tooltip.hover
                  :title="
                    group.health.dnsProblems + ' sistema(s) con alertas DNS'
                  "
                >
                  <AppIcon name="language" /> {{ group.health.dnsProblems }} DNS
                </span>
                <span
                  v-if="group.health.processing"
                  class="instances-docker-group-card__health-item instances-docker-group-card__health-item--info"
                  v-b-tooltip.hover
                  :title="
                    group.health.processing +
                    ' sistema(s) en instalación o actualización'
                  "
                >
                  <AppIcon
                    name="progress_activity"
                    class="instances-process-indicator__icon"
                  />
                  {{ group.health.processing }} procesando
                </span>
                <span
                  v-if="!getDockerGroupPriority(group.health)"
                  class="instances-docker-group-card__health-item instances-docker-group-card__health-item--success"
                >
                  <AppIcon name="check_circle" /> Saludable
                </span>
              </div>
              <AppIcon
                v-if="dockerViewMode != 'full'"
                class="instances-docker-group-card__toggle"
                :name="
                  isDockerGroupOpen(group.id) ? 'expand_less' : 'expand_more'
                "
              />
            </button>

            <b-collapse
              :visible="isDockerGroupOpen(group.id)"
              class="instances-docker-group-card__body"
            >
              <div
                v-if="dockerViewMode == 'cards'"
                class="instances-docker-group-card__cards"
              >
                <article
                  v-for="system in group.items"
                  :key="system.id"
                  class="instances-docker-card"
                >
                  <div class="instances-docker-card__heading">
                    <div>
                      <div class="instances-docker-card__title">
                        <span class="instances-docker-card__id"
                          >#{{ system.id }}</span
                        >
                        <h4>{{ system.name }}</h4>
                      </div>
                      <div
                        v-if="system.customer || system.service_customer"
                        class="instances-docker-card__meta"
                      >
                        <span v-if="system.customer"
                          ><AppIcon name="business" />
                          {{ system.customer.name }}</span
                        >
                        <b-badge
                          v-if="system.customer && !system.customer.active"
                          variant="danger"
                          >Cliente inactivo</b-badge
                        >
                        <b-badge
                          v-if="system.service_customer"
                          variant="info"
                          v-b-tooltip.hover
                          :title="system.service_customer.name"
                          ><AppIcon name="rocket_launch" /> Servicio</b-badge
                        >
                      </div>
                      <div
                        v-if="
                          system.server ||
                          system.server_backups ||
                          system.status_process
                        "
                        class="instances-docker-card__infrastructure"
                      >
                        <span
                          v-if="system.server"
                          class="instances-docker-card__server"
                          ><AppIcon name="dns" /> {{ system.server.name }}</span
                        >
                        <span
                          v-if="system.server_backups"
                          class="instances-docker-card__server"
                          ><AppIcon name="backup" />
                          {{ system.server_backups.name }}</span
                        >
                        <span
                          v-if="system.status_process"
                          class="instances-process-indicator"
                          ><AppIcon
                            name="progress_activity"
                            class="instances-process-indicator__icon"
                          />
                          Procesando</span
                        >
                      </div>
                    </div>
                    <b-dropdown
                      right
                      no-caret
                      size="sm"
                      variant="link"
                      boundary="window"
                      toggle-class="app-table-action-toggle"
                    >
                      <template #button-content
                        ><AppIcon name="more_vert" label="Opciones"
                      /></template>
                      <b-dropdown-item @click="actionSystem(system)"
                        ><AppIcon name="terminal" /> Comandos</b-dropdown-item
                      >
                      <b-dropdown-divider />
                      <b-dropdown-item @click="edit(system)"
                        ><AppIcon name="edit" /> Editar</b-dropdown-item
                      >
                      <b-dropdown-item @click="remove(system)"
                        ><AppIcon name="delete" class="text-danger" />
                        Eliminar</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>

                  <div class="instances-docker-card__links">
                    <b-link
                      v-if="system.domain"
                      target="_blank"
                      :href="'http://' + system.domain"
                      ><AppIcon name="language" /> {{ system.domain }}</b-link
                    >
                    <span v-else class="text-danger"
                      ><AppIcon name="warning" /> Sin dominio configurado</span
                    >
                  </div>

                  <div class="instances-docker-card__metrics">
                    <section
                      class="instances-docker-card__section instances-docker-card__section--controls"
                    >
                      <span class="instances-docker-card__section-label"
                        >Controles</span
                      >
                      <div
                        v-if="getDockerChecks(system).length"
                        class="instances-docker-checks"
                      >
                        <span
                          v-for="check in getDockerChecks(system)"
                          :key="check.key"
                          :id="'docker-check-' + check.key + '-' + system.id"
                          class="instances-docker-check"
                          :class="getDockerCheckTone(system, check.key)"
                        >
                          <AppIcon
                            :name="check.icon"
                            font-scale="1.65"
                            weight="500"
                          /><span>{{ check.label }}</span
                          ><small>{{
                            getDockerCheckStatus(system, check.key)
                          }}</small>
                          <b-popover
                            :target="
                              'docker-check-' + check.key + '-' + system.id
                            "
                            triggers="hover"
                            placement="top"
                          >
                            <template #title
                              ><AppIcon :name="check.icon" class="mr-1" />
                              {{ check.label }}</template
                            >
                            <b>Estado:</b>
                            {{ getDockerCheckStatus(system, check.key) }}<br />
                            <span
                              v-if="
                                check.key == 'backups' &&
                                getDockerDetails(system, 'backups').last
                              "
                              ><b>Último backup:</b>
                              {{ getDockerDetails(system, "backups").last }}<br
                            /></span>
                            <span
                              v-if="
                                check.key == 'access' &&
                                getDockerDetails(system, 'access').domain
                              "
                              ><b>Dominio HTTPS:</b>
                              {{ getDockerDetails(system, "access").domain
                              }}<br
                            /></span>
                            <span
                              v-if="
                                check.key == 'access' &&
                                getDockerDetails(system, 'access').domain_http
                              "
                              ><b>Dominio HTTP:</b>
                              {{ getDockerDetails(system, "access").domain_http
                              }}<br
                            /></span>
                            <span
                              v-if="check.key == 'dns' && showDnsProxy(system)"
                              ><b>Detalle:</b> {{ getDnsProxyTitle(system)
                              }}<br
                            /></span>
                            <span v-else-if="check.key == 'dns'"
                              ><b>Detalle:</b> {{ getDockerDnsDetail(system)
                              }}<br
                            /></span>
                            <span
                              v-if="
                                check.key != 'dns' &&
                                getDockerDetails(system, check.key).datetime
                              "
                              ><b>Última sincronización:</b>
                              {{
                                moment(
                                  getDockerDetails(system, check.key).datetime
                                ).format("DD/MM/YYYY HH:mm:ss")
                              }}</span
                            >
                          </b-popover>
                        </span>
                      </div>
                      <span v-else class="text-muted">Sin controles</span>
                    </section>
                  </div>

                  <div
                    v-if="system.observations || system.observations_backups"
                    class="instances-docker-card__alerts"
                  >
                    <div
                      v-if="system.observations"
                      class="instances-docker-card__alert"
                    >
                      <AppIcon name="chat" />
                      <div>
                        <b>Observaciones</b
                        ><span>{{ system.observations }}</span>
                      </div>
                    </div>
                    <div
                      v-if="system.observations_backups"
                      class="instances-docker-card__alert instances-docker-card__alert--backup"
                    >
                      <AppIcon name="shield" />
                      <div>
                        <b>Backups</b
                        ><span>{{ system.observations_backups }}</span>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
              <div v-else class="instances-docker-tree-view">
                <article
                  v-for="system in group.items"
                  :key="system.id"
                  class="instances-docker-tree-view__system"
                >
                  <span class="instances-docker-tree-view__branch"
                    ><AppIcon name="deployed_code"
                  /></span>
                  <div class="instances-docker-tree-view__header">
                    <div class="instances-docker-card__title">
                      <span class="instances-docker-card__id"
                        >#{{ system.id }}</span
                      >
                      <h4>{{ system.name }}</h4>
                      <b-link
                        v-if="system.domain"
                        :href="'http://' + system.domain"
                        target="_blank"
                        class="instances-docker-tree-view__link"
                        ><AppIcon name="language" /> {{ system.domain }}</b-link
                      ><span
                        :id="'docker-tree-info-' + system.id"
                        tabindex="0"
                        class="instances-docker-tree-view__more"
                        ><AppIcon name="info" label="Ver más" /></span
                      ><b-popover
                        :target="'docker-tree-info-' + system.id"
                        triggers="hover focus click blur"
                        placement="top"
                        custom-class="instances-tree-info-popover"
                        ><template #title
                          ><AppIcon name="info" class="mr-1" />
                          {{ system.name }}</template
                        ><b v-if="system.customer">Cliente:</b
                        ><span v-if="system.customer">
                          {{ system.customer.name }}<br /></span
                        ><b v-if="system.service_customer">Servicio:</b
                        ><span v-if="system.service_customer">
                          {{ system.service_customer.name }}<br /></span
                        ><b v-if="system.server">Servidor de instalación:</b
                        ><span v-if="system.server">
                          {{ system.server.name }}<br /></span
                        ><b v-if="system.server_backups">Servidor de backups:</b
                        ><span v-if="system.server_backups">
                          {{ system.server_backups.name }}<br /></span
                        ><span v-if="system.status_process"
                          ><b>Proceso:</b> En curso<br /></span
                        ><span v-if="system.observations"
                          ><b>Observaciones:</b> {{ system.observations
                          }}<br /></span
                        ><span v-if="system.observations_backups"
                          ><b>Observaciones de backups:</b>
                          {{ system.observations_backups }}</span
                        ></b-popover
                      >
                    </div>
                    <b-dropdown
                      right
                      no-caret
                      size="sm"
                      variant="link"
                      boundary="window"
                      toggle-class="app-table-action-toggle"
                      ><template #button-content
                        ><AppIcon name="more_vert" label="Opciones" /></template
                      ><b-dropdown-item @click="actionSystem(system)"
                        ><AppIcon name="terminal" /> Comandos</b-dropdown-item
                      ><b-dropdown-divider /><b-dropdown-item
                        @click="edit(system)"
                        ><AppIcon name="edit" /> Editar</b-dropdown-item
                      ><b-dropdown-item @click="remove(system)"
                        ><AppIcon name="delete" class="text-danger" />
                        Eliminar</b-dropdown-item
                      ></b-dropdown
                    >
                  </div>
                  <div class="instances-docker-tree-view__details">
                    <span
                      v-if="system.status_process"
                      class="instances-process-indicator"
                      ><AppIcon
                        name="progress_activity"
                        class="instances-process-indicator__icon"
                      />
                      Procesando</span
                    ><span
                      v-for="check in getDockerChecks(system)"
                      :key="check.key"
                      :id="'docker-tree-' + check.key + '-' + system.id"
                      class="instances-docker-tree-view__item"
                      :class="getDockerCheckTone(system, check.key)"
                      ><AppIcon :name="check.icon" /><b>{{ check.label }}</b
                      ><span>{{ getDockerCheckStatus(system, check.key) }}</span
                      ><b-popover
                        :target="'docker-tree-' + check.key + '-' + system.id"
                        triggers="hover"
                        placement="top"
                        ><template #title
                          ><AppIcon :name="check.icon" class="mr-1" />
                          {{ check.label }}</template
                        ><b>Estado:</b>
                        {{ getDockerCheckStatus(system, check.key) }}<br /><span
                          v-if="
                            check.key == 'backups' &&
                            getDockerDetails(system, 'backups').last
                          "
                          ><b>Último backup:</b>
                          {{ getDockerDetails(system, "backups").last
                          }}<br /></span
                        ><span
                          v-if="
                            check.key == 'access' &&
                            getDockerDetails(system, 'access').domain
                          "
                          ><b>Dominio HTTPS:</b>
                          {{ getDockerDetails(system, "access").domain
                          }}<br /></span
                        ><span
                          v-if="
                            check.key == 'access' &&
                            getDockerDetails(system, 'access').domain_http
                          "
                          ><b>Dominio HTTP:</b>
                          {{ getDockerDetails(system, "access").domain_http
                          }}<br /></span
                        ><span v-if="check.key == 'dns' && showDnsProxy(system)"
                          ><b>Detalle:</b> {{ getDnsProxyTitle(system)
                          }}<br /></span
                        ><span v-else-if="check.key == 'dns'"
                          ><b>Detalle:</b> {{ getDockerDnsDetail(system)
                          }}<br /></span
                        ><span
                          v-if="
                            check.key != 'dns' &&
                            getDockerDetails(system, check.key).datetime
                          "
                          ><b>Última sincronización:</b>
                          {{
                            moment(
                              getDockerDetails(system, check.key).datetime
                            ).format("DD/MM/YYYY HH:mm:ss")
                          }}</span
                        ></b-popover
                      ></span
                    >
                  </div>
                </article>
              </div>
            </b-collapse>
          </b-card>
        </div>
        <EmptyState
          v-else
          icon="deployed_code"
          title="No se encontraron sistemas Docker"
        />

        <b-table
          v-if="false"
          class="app-table mb-0"
          ref="table"
          responsive="sm"
          :hover="true"
          :fixed="false"
          sticky-header="60vh"
          :stacked="isMobileViewport ? 'md' : false"
          :items="table.items"
          :fields="table.fields"
          :current-page="table.currentPage"
          :per-page="table.perPage"
          :busy="table.isBusy"
        >
          <template v-slot:cell(id)="data">
            <b>#{{ data.item.id }}</b>
          </template>

          <template v-slot:cell(name)="data">
            <b>{{ data.item.name }}</b>
            <b-badge
              variant="secondary"
              class="ml-2"
              v-if="data.item.categorie"
              >{{ data.item.categorie.name }}</b-badge
            >

            <span>
              <br />
              <span v-if="data.item.domain">
                <b-link target="_blank" :href="'http://' + data.item.domain">
                  https://{{ data.item.domain }}
                </b-link>
              </span>
              <span v-else class="text-danger">
                [Falta configuración de dominio para el sistema]
              </span>
            </span>
          </template>

          <template v-slot:cell(customer_id)="data">
            <div v-if="data.item.customer">
              <b-avatar
                :src="data.item.customer.image"
                v-if="data.item.customer.image"
              >
              </b-avatar>
              <b-avatar v-else icon="building" variant="dark"> </b-avatar>
              &nbsp;<b>{{ data.item.customer.name }}</b>

              <AppIcon
                name="error"
                v-if="!data.item.customer.active"
                class="ml-2 text-danger"
                v-b-tooltip.hover
                title="Cliente INACTIVO"
              />
            </div>
          </template>

          <template v-slot:cell(observations)="data">
            <div
              v-if="data.item.observations"
              v-b-tooltip.hover
              :title="data.item.observations"
            >
              <AppIcon name="chat" />
            </div>
          </template>

          <template v-slot:cell(instances_server_id)="data">
            <span v-if="data.item.server">
              <b>{{ data.item.server.name }}</b
              ><br />
              <span v-if="data.item.server.subdomain">
                <b-link
                  target="_blank"
                  :href="'http://' + data.item.server.subdomain"
                >
                  https://{{ data.item.server.subdomain }}
                </b-link>
              </span>
            </span>
          </template>

          <template v-slot:cell(services)="data">
            <div
              v-if="data.item.service_customer"
              v-b-tooltip.hover
              :title="data.item.service_customer.name"
              style="cursor: pointer"
            >
              <AppIcon name="rocket_launch" />
            </div>
          </template>

          <template v-slot:cell(instances_server_backups_id)="data">
            <span v-if="data.item.server_backups">
              <b>{{ data.item.server_backups.name }}</b>
            </span>
            &nbsp;&nbsp;
            <span
              v-if="data.item.observations_backups"
              v-b-tooltip.hover
              :title="data.item.observations_backups"
              style="cursor: pointer"
            >
              <AppIcon name="shield" class="text-danger" />
            </span>
          </template>

          <template v-slot:cell(backups)="data">
            <div
              v-if="
                data.item.control_backups &&
                data.item.route_folder_backups_docker
              "
            >
              <div v-if="data.item.backups">
                <div
                  v-if="showFieldSystem(data.item, 'backups') == 'Activo'"
                  class="text-success font-weight-bold"
                  :id="'server-backups-' + data.item.id"
                >
                  <AppIcon name="circle" class="text-success" fill />
                </div>
                <div
                  v-if="showFieldSystem(data.item, 'backups') == 'Inactivo'"
                  class="text-danger font-weight-bold"
                  :id="'server-backups-' + data.item.id"
                >
                  <AppIcon name="circle" class="text-danger" fill />
                </div>
              </div>
            </div>

            <b-popover
              :target="'server-backups-' + data.item.id"
              triggers="hover"
              placement="top"
              v-if="data.item.backups"
            >
              <template #title>Estado del Backups</template>
              <b>Estado:</b> {{ JSON.parse(data.item.backups).status }}<br />
              <b>Últimos Backups:</b> {{ JSON.parse(data.item.backups).last
              }}<br />
              <b>Última Sincronización:</b>
              {{
                moment(JSON.parse(data.item.backups).datetime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )
              }}
            </b-popover>
          </template>

          <template v-slot:cell(status_process)="data">
            <div v-if="data.item.status_process">
              <span class="instances-process-indicator"
                ><AppIcon
                  name="progress_activity"
                  class="instances-process-indicator__icon"
                />
                Procesando</span
              >
            </div>
          </template>

          <template v-slot:cell(access)="data">
            <div v-if="data.item.domain && data.item.access">
              <div
                v-if="showFieldSystem(data.item, 'access') == 'Activo'"
                class="text-success font-weight-bold"
                :id="'server-access-' + data.item.id"
              >
                <AppIcon name="circle" class="text-success" fill />
              </div>
              <div
                v-if="showFieldSystem(data.item, 'access') == 'Inactivo'"
                class="text-danger font-weight-bold"
                :id="'server-access-' + data.item.id"
              >
                <AppIcon name="circle" class="text-danger" fill />
              </div>
            </div>

            <b-popover
              :target="'server-access-' + data.item.id"
              triggers="hover"
              placement="top"
              @show="configViewerJson"
              v-if="data.item.domain && data.item.access"
            >
              <template #title>Accesos URL</template>
              <b>Estado:</b> {{ JSON.parse(data.item.access).status }}<br />
              <div v-if="JSON.parse(data.item.access).domain">
                <b>Dominio HTTPS:</b> {{ JSON.parse(data.item.access).domain
                }}<br />
              </div>
              <div v-if="JSON.parse(data.item.access).domain_http">
                <b>Dominio HTTP:</b>
                {{ JSON.parse(data.item.access).domain_http }}<br />
              </div>
              <b>Última Sincronización:</b>
              {{
                moment(JSON.parse(data.item.access).datetime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )
              }}
            </b-popover>
          </template>

          <template v-slot:cell(dns)="data">
            <div v-if="data.item.domain && data.item.access">
              <AppIcon
                v-if="showDnsTypeAAAA(data.item)"
                name="info"
                class="mr-1 text-info"
                v-b-tooltip.hover
                title="Encontramos registros tipo AAAA en los DNS"
              />
              <AppIcon
                v-if="showDnsErrorIp(data.item)"
                name="folder_shared"
                class="mr-1 text-info"
                v-b-tooltip.hover
                title="La IP asociada al registro tipo A no coincide con la IP del servidor y no responde como Zyncro"
              />
              <AppIcon
                v-if="showDnsProxy(data.item)"
                name="lan"
                class="mr-1 text-primary"
                v-b-tooltip.hover
                :title="getDnsProxyTitle(data.item)"
              />
            </div>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown
              right
              no-caret
              size="sm"
              variant="link"
              boundary="window"
              toggle-class="app-table-action-toggle"
            >
              <b-dropdown-item @click="actionSystem(data.item)">
                <AppIcon name="terminal" /> Comandos
              </b-dropdown-item>
              <b-dropdown-item @click="edit(data.item)">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <AppIcon name="delete" class="text-danger" /> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>

      <div class="list-view-footer">
        <b-row>
          <b-col>
            <b-button
              type="button"
              variant="outline-dark"
              size="sm"
              @click="$router.go(-1)"
            >
              <AppIcon name="arrow_back" class="mr-1" /> Volver
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal
        v-model="modal.form.active"
        body-class="app-modal-form"
        :key="modal.form._id"
        :id="modal.form._id"
      >
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"
            ><AppIcon :name="crud.form.id ? 'edit' : 'add'"
          /></span>
          <h5 class="app-modal-header__title">{{ this.modal.form.title }}</h5>
        </div>

        <b-tabs
          active-nav-item-class="font-weight-bold text-uppercase text-dark"
        >
          <b-tab title="General">
            <b-row>
              <b-col md="12">
                <b-form-group label="Nombre">
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="crud.form.name"
                    required
                    placeholder="Ingresar un nombre"
                    :disabled="crud.form.id > 0"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <FindObject
                  render="search"
                  type="customers"
                  @select-object="loadCustomers($event)"
                  :valueID="crud.form.customer_id"
                  :where="conditionCustomersActive"
                />
              </b-col>
              <b-col md="12">
                <FindObject
                  tag="VPS Instalación"
                  render="search"
                  type="instances-server"
                  @select-object="loadInstancesServer($event)"
                  :valueID="crud.form.instances_server_id"
                  :orWhere="conditionServerType"
                />
              </b-col>
              <b-col md="12">
                <FindObject
                  tag="Agrupación"
                  render="search"
                  type="instances-categories"
                  @select-object="loadInstancesCategories($event)"
                  :valueID="crud.form.categories_id"
                  :where="filterCategoriesSystem"
                />
              </b-col>

              <b-col md="12">
                <b-form-group
                  label="Ruta Instalación Proyecto"
                  description="Se necesita la ruta donde esta contenida la carpeta .git"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="crud.form.route_folder_backups_others"
                    required
                    placeholder="Ingresar una Ruta"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <hr />
              </b-col>

              <b-col md="12" v-if="parameters.integrateServices">
                <FindObject
                  tag="Servicio"
                  render="search"
                  display="name"
                  type="servicesCustomers"
                  @select-object="loadServicesCustomersDetails($event)"
                  :valueID="crud.form.services_customers_details_id"
                  :where="conditionServicesCustomersDetails"
                  :key="crud.form.customer_id"
                />
              </b-col>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations"
                    lazy
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Backups">
            <b-row>
              <b-col md="12">
                <b-form-checkbox
                  v-model="crud.form.control_backups"
                  switch
                  size="sm"
                  class="pull-left mt-2 mb-2"
                >
                  ¿Hacer backups diariamente?
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row v-if="crud.form.control_backups">
              <b-col md="12">
                <FindObject
                  tag="VPS Backups"
                  render="search"
                  type="instances-server"
                  @select-object="loadInstancesServerBackups($event)"
                  :valueID="crud.form.instances_server_backups_id"
                  :where="conditionServerBackupsType"
                />
              </b-col>

              <b-col md="12">
                <b-form-group
                  label="Ruta Búsqueda Backups"
                  description="El sistema dentro de docker, es el encargado de generar su propio backups"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="crud.form.route_folder_backups_docker"
                    required
                    placeholder="Ingresar una Ruta de Búsqueda"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations_backups"
                    lazy
                    placeholder="Ingresar las observaciones sobre el backups..."
                    rows="3"
                    max-rows="6"
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="modal.form.active = false"
            ><AppIcon name="close" class="mr-1" /> Cancelar</b-button
          >
          <b-button variant="dark" @click="save()"
            ><AppIcon name="save" class="mr-1" /> Guardar</b-button
          >
        </div>
      </b-modal>

      <!-- CRUD COMMAND -->
      <b-modal
        v-model="modal.command.active"
        size="lg"
        :key="modal.command._id"
        :id="modal.command._id"
      >
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"
            ><AppIcon name="terminal"
          /></span>
          <h5 class="app-modal-header__title">
            {{ this.modal.command.title }}
          </h5>
        </div>

        <b-row v-if="selectedSystem">
          <b-col md="3" class="instances-docker-command-panel-column">
            <aside class="instances-docker-command-panel">
              <h6><AppIcon name="terminal" /> Comandos</h6>
              <section class="instances-docker-command-group">
                <b-button
                  v-b-toggle.docker-command-system
                  variant="link"
                  class="instances-docker-command-group__toggle"
                  ><span><AppIcon name="deployed_code" /> Sistema</span
                  ><AppIcon name="expand_more"
                /></b-button>
                <b-collapse
                  id="docker-command-system"
                  visible
                  accordion="docker-commands"
                  ><div class="instances-docker-command-group__actions">
                    <span
                      v-if="selectedSystem.domain"
                      class="instances-docker-command-subsection"
                      >Consulta</span
                    >
                    <b-button
                      v-if="selectedSystem.domain"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-others-get-version',
                          'Obtener Versión'
                        )
                      "
                      ><AppIcon name="info" /> Versión</b-button
                    >
                    <b-button
                      v-if="selectedSystem.domain"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-others-check-access',
                          'Verificar Acceso'
                        )
                      "
                      ><AppIcon name="link" /> Verificar acceso</b-button
                    >
                    <span class="instances-docker-command-subsection"
                      >Administración</span
                    >
                    <b-button
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-others-domain',
                          'Apuntar Dominio'
                        )
                      "
                      ><AppIcon name="language" /> Apuntar dominio</b-button
                    >
                  </div></b-collapse
                >
              </section>
              <section
                v-if="showBackups"
                class="instances-docker-command-group"
              >
                <b-button
                  v-b-toggle.docker-command-backups
                  variant="link"
                  class="instances-docker-command-group__toggle"
                  ><span><AppIcon name="backup" /> Backups</span
                  ><AppIcon name="expand_more"
                /></b-button>
                <b-collapse
                  id="docker-command-backups"
                  accordion="docker-commands"
                  ><div class="instances-docker-command-group__actions">
                    <span
                      v-if="selectedSystem.backups"
                      class="instances-docker-command-subsection"
                      >Consulta</span
                    >
                    <b-button
                      v-if="selectedSystem.backups"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem('system-backups-get-now', 'Backups Hoy')
                      "
                      ><AppIcon name="backup" /> Backups hoy</b-button
                    >
                    <b-button
                      v-if="selectedSystem.backups"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-backups-list-img',
                          'Listar Archivos'
                        )
                      "
                      ><AppIcon name="image" /> Listar archivos</b-button
                    >
                    <span
                      v-if="selectedSystem.backups"
                      class="instances-docker-command-subsection"
                      >Forzar</span
                    >
                    <b-button
                      v-if="selectedSystem.backups"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-others-backups-force-files',
                          'Forzar Backups: ARCHIVOS'
                        )
                      "
                      ><AppIcon name="backup" /> Archivos</b-button
                    >
                    <span class="instances-docker-command-subsection"
                      >Administración</span
                    >
                    <b-button
                      v-if="!showConfigurateBackupsActive()"
                      variant="link"
                      class="instances-docker-command-action"
                      @click="
                        getActionSystem(
                          'system-others-backups-configurate',
                          'Configurar Backups'
                        )
                      "
                      ><AppIcon name="settings" /> Configurar</b-button
                    >
                    <b-button
                      v-if="showConfigurateBackupsActive()"
                      variant="link"
                      class="instances-docker-command-action instances-docker-command-action--danger"
                      @click="
                        getActionSystem(
                          'system-others-backups-delete',
                          'Quitar Backups'
                        )
                      "
                      ><AppIcon name="delete" /> Quitar</b-button
                    >
                  </div></b-collapse
                >
              </section>
            </aside>
          </b-col>
          <b-col md="9" class="app-command-terminal-column">
            <section class="app-command-terminal">
              <div class="app-command-terminal__header">
                <h4>{{ this.modal.command.subtitle }}</h4>
                <div class="app-command-terminal__actions">
                  <span v-if="selectedSystem.status_process">
                    <span class="app-command-terminal__process"
                      ><AppIcon name="progress_activity" /> Procesando</span
                    >
                  </span>
                  <b-button
                    v-if="!SSHLoader && SSHConsole"
                    variant="outline-secondary"
                    size="sm"
                    class="app-command-terminal__copy"
                    @click="copySSHConsole()"
                  >
                    <AppIcon name="content_copy" class="mr-1" /> Copiar
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    class="app-command-terminal__refresh"
                    title="Refrescar"
                    @click="refreshSystem()"
                    v-if="!SSHLoader"
                  >
                    <AppIcon name="refresh" label="Refrescar" />
                  </b-button>
                </div>
              </div>
              <div
                v-if="!SSHLoader"
                ref="sshConsole"
                class="ssh-console-system"
                v-html="SSHConsole"
              ></div>
              <div v-else class="app-command-terminal__loader">
                <b-spinner label="Spinning" type="grow"></b-spinner>
              </div>
            </section>
          </b-col>
        </b-row>

        <div slot="modal-footer" class="ssh-console-footer">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="closeActionSystem()"
            ><AppIcon name="x" class="mr-1" /> Cerrar</b-button
          >
        </div>
      </b-modal>

      <!-- CRUD DOMAIN SYSTEM -->
      <b-modal
        v-model="modal.formSystem.active"
        size="xl"
        body-class="app-modal-form"
      >
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"
            ><AppIcon name="language"
          /></span>
          <h5 class="app-modal-header__title">
            {{ this.modal.formSystem.title }}
          </h5>
        </div>

        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="12">
                <b-form-group label="Domino">
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="crud.formSystem.domain"
                    required
                    placeholder="Ingresa un dominio"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12" class="mt-3">
                <b-alert variant="info" show>
                  Puede demorar unas horas en quedar activo. Dependerá de la
                  propagación de los DNS de su proveedor de dominios.
                </b-alert>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6" v-if="this.selectedSystem">
            <b-card
              bg-variant="light"
              header="Implementación"
              text-variant="dark"
            >
              <b-card-text>
                <p>
                  Para apuntar su dominio personalizado al sistema, siga los
                  siguientes pasos:
                </p>

                <hr />

                <ul>
                  <li>Ingresar a la <b>zona DNS</b> de su dominio.</li>
                  <li>
                    Buscar el registro <b>(Tipo A => su-dominio.com => [IP])</b>
                  </li>
                  <li>
                    Editar la IP actual por la IP de nuestro servidor.
                    <b>IP = {{ this.selectedSystem.server.host }}</b>
                  </li>
                  <li>
                    El siguiente registro debe mantener esta estructura
                    <b>(CNAME => www.su-dominio.com => su-dominio.com)</b>
                  </li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="modal.formSystem.active = false"
            ><AppIcon name="close" class="mr-1" /> Cancelar</b-button
          >
          <b-button variant="dark" @click="saveDomain()"
            ><AppIcon name="link" class="mr-1" /> Apuntar</b-button
          >
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
import serviceAPI from "./services";
import Error from "@/handler/error";
import Session from "@/handler/session";
import Profiles from "@/config/profiles";
import Modules from "@/config/modules";
import Helper from "@/handler/helper";
import Param from "@/config/parameters";
import FindObject from "@/components/inc/find/findObject";
import Storage from "@/handler/storageLocal";
import TabHeaderActions from "@/components/inc/tabs/TabHeaderActions";

export default {
  components: {
    FindObject,
    TabHeaderActions,
  },
  data: () => {
    return {
      access: {
        module_id: Modules.INSTANCIAS,
        profile_id: Profiles.PERSONAL,
        view_reference: "crudInstancesSystemDocker",
        elements: {},
      },
      table: {
        items: [],
        fields: [],
        currentPage: 1,
        perPage: 0,
        isBusy: false,
        tablePaginate: null,
      },
      filtersOpen: false,
      dockerViewMode: "tree",
      isMobileViewport: false,
      expandedDockerGroups: {},
      parameters: {
        integrateServices: Helper.hasParametersAccess(Param.P59),
      },
      crud: {
        form: {
          id: 0,
          name: "",
          customer_id: 0,
          customer: null,
          instances_server_id: 0,
          instances_server: null,
          instances_server_backups_id: 0,
          instances_server_backups: null,
          services_customers_details_id: 0,
          services_customers_details: null,
          categories_id: 0,
          categories: null,
          observations: "",
          own: false,
          type: "docker",
          name_db_backups_others: "",
          route_folder_backups_others: "",
          route_folder_backups_docker: "",
          control_backups: false,
          observations_backups: "",
        },
        formSystem: {
          id: 0,
          domain: "",
          exists: false,
        },
      },
      modal: {
        form: {
          active: false,
          title: "",
        },
        command: {
          active: false,
          title: "",
          subtitle: "Terminal",
        },
        formSystem: {
          active: false,
          title: "",
          showCheck: false,
        },
      },
      filters: {
        name: "",
        customer: 0,
        instances_server: 0,
        categories: null,
        own: false,
        type: "docker",
        health: { code: "all", label: "Todos" },
      },
      filterType: "system",
      arr: {
        select: {
          customers: [],
          instances_servers: [],
          categories: [],
        },
        filter: {
          health: [
            { code: "all", label: "Todos" },
            { code: "alerts", label: "Con alertas operativas" },
            { code: "without_backups", label: "Sin backups activos" },
            { code: "access_problems", label: "Con problemas de acceso" },
            { code: "dns_problems", label: "Con alertas DNS" },
          ],
        },
      },
      selectedServer: null,
      selectedSystem: null,
      SSHConsole: "",
      SSHLoader: false,
    };
  },
  created() {
    /* Configurar permisos de vistas y elementos */
    Helper.hasAccessView(this.access);
    /* Fin configuracion */
  },
  mounted() {
    this.filterLoadSelects();
    this.restoreFilterStorage();
    this.filtersOpen =
      Storage.getValue("filters_open_crud_instances_system_docker") == "true";
    var storedDockerViewMode = Storage.getValue(
      "view_mode_crud_instances_system_docker"
    );
    this.dockerViewMode =
      ["cards", "full"].indexOf(storedDockerViewMode) >= 0
        ? storedDockerViewMode
        : "tree";
    this.mobileMql = window.matchMedia("(max-width: 767.98px)");
    this.isMobileViewport = this.mobileMql.matches;
    this.mobileMql.addEventListener("change", this.updateMobileViewport);

    this.loadFieldTable();

    this.filter();
    this.configViewerJson();
  },
  watch: {
    filtersOpen(value) {
      Storage.setValue(
        "filters_open_crud_instances_system_docker",
        value ? "true" : "false"
      );
    },
    dockerViewMode(value) {
      Storage.setValue("view_mode_crud_instances_system_docker", value);
    },
  },
  beforeDestroy() {
    if (this.mobileMql) {
      this.mobileMql.removeEventListener("change", this.updateMobileViewport);
    }
  },
  computed: {
    groupedDockerSystems() {
      var groups = {};
      this.table.items.forEach((item) => {
        var category = item.categorie || {
          id: "uncategorized",
          name: "Sin categoría",
        };
        var key = category.id || "uncategorized";
        if (!groups[key]) {
          groups[key] = { id: key, name: category.name, items: [] };
        }
        groups[key].items.push(item);
      });
      return Object.keys(groups).map((key) => {
        groups[key].health = this.getDockerGroupHealth(groups[key].items);
        return groups[key];
      });
    },
    // CONDITIONS SELECT
    filterCategoriesSystem() {
      return [{ field: "type", condition: this.filterType }];
    },
    conditionCustomersActive() {
      return [{ field: "active", condition: true }];
    },
    conditionServerType() {
      return [
        { field: "type", condition: "docker" },
        { field: "show_docker", condition: true },
      ];
    },
    conditionServerBackupsType() {
      return [{ field: "type", condition: "backups" }];
    },
    conditionServicesCustomersDetails() {
      return [
        { field: "customer_id", condition: this.crud.form.customer_id },
        { field: "canceled", condition: false },
        { field: "type_instances", condition: "other_system" },
      ];
    },

    // render
    showBackups() {
      if (
        this.selectedSystem.control_backups &&
        this.selectedSystem.route_folder_backups_docker
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // config
    confirmDialog(message, options) {
      var danger = !!options.danger;
      var icon = options.icon || (danger ? "warning" : "help");
      var title = this.$createElement(
        "span",
        { class: "app-confirm-header__title" },
        [
          this.$createElement("AppIcon", { props: { name: icon } }),
          options.title,
        ]
      );

      return this.$bvModal.msgBoxConfirm(message, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: danger ? "danger" : "dark",
        okTitle: options.okTitle,
        cancelTitle: options.cancelTitle || "Cancelar",
        footerClass: "p-2",
        headerClass: danger
          ? "app-confirm-header app-confirm-header--danger"
          : "app-confirm-header",
        hideHeaderClose: false,
        centered: true,
      });
    },
    updateMobileViewport(event) {
      this.isMobileViewport = event.matches;
    },
    isDockerGroupOpen(id) {
      if (this.dockerViewMode == "full") return true;
      return !!this.expandedDockerGroups[id];
    },
    toggleDockerGroup(id) {
      if (this.dockerViewMode == "full") return;
      this.$set(this.expandedDockerGroups, id, !this.isDockerGroupOpen(id));
    },
    syncDockerGroupsExpansion(items) {
      var groupIds = {};
      items.forEach((item) => {
        var key =
          item.categorie && item.categorie.id
            ? item.categorie.id
            : "uncategorized";
        groupIds[key] = true;
      });
      var groupKeys = Object.keys(groupIds);
      var hasPreviousState = Object.keys(this.expandedDockerGroups).length > 0;
      var expandedGroups = {};
      groupKeys.forEach((key) => {
        expandedGroups[key] = hasPreviousState
          ? !!this.expandedDockerGroups[key]
          : groupKeys.length == 1;
      });
      this.expandedDockerGroups = expandedGroups;
    },
    getDockerDetails(item, type) {
      if (!item[type]) return {};
      try {
        return JSON.parse(item[type]) || {};
      } catch (error) {
        return {};
      }
    },
    getDockerCheckLabel(item, type) {
      return this.getDockerDetails(item, type).status || "Sin estado";
    },
    getDockerCheckVariant(item, type) {
      return this.getDockerCheckLabel(item, type) == "Activo"
        ? "success"
        : "danger";
    },
    getDockerChecks(item) {
      var checks = [
        {
          key: "backups",
          label: "Backups",
          icon: "backup",
          title: "Estado de backups",
        },
        {
          key: "access",
          label: "Accesos",
          icon: "link",
          title: "Estado de accesos URL",
        },
      ].filter((check) => item[check.key]);
      if (item.domain && item.access) {
        checks.push(
          this.showDnsProxy(item)
            ? { key: "dns", label: "Proxy", icon: "lan", title: "Proxy Zyncro" }
            : {
                key: "dns",
                label: "DNS",
                icon: "language",
                title: "Estado de DNS",
              }
        );
      }
      return checks;
    },
    getDockerCheckStatus(item, key) {
      if (key == "dns") return this.getDockerDnsLabel(item);
      return this.getDockerDetails(item, key).status || "Sin estado";
    },
    getDockerCheckTone(item, key) {
      if (key == "dns")
        return this.hasDockerDnsProblem(item) ? "text-danger" : "text-success";
      return this.getDockerCheckStatus(item, key) == "Activo"
        ? "text-success"
        : "text-danger";
    },
    isDockerWithoutBackups(item) {
      return (
        item.control_backups &&
        item.route_folder_backups_docker &&
        this.getDockerCheckStatus(item, "backups") != "Activo"
      );
    },
    hasDockerAccessProblem(item) {
      return (
        item.domain &&
        item.access &&
        this.getDockerCheckStatus(item, "access") != "Activo"
      );
    },
    hasDockerDnsProblem(item) {
      return (
        item.domain &&
        item.access &&
        (this.showDnsTypeAAAA(item) || this.showDnsErrorIp(item))
      );
    },
    matchesSelectedHealth(item) {
      var health = this.filters.health ? this.filters.health.code : "all";
      if (health == "without_backups") return this.isDockerWithoutBackups(item);
      if (health == "access_problems") return this.hasDockerAccessProblem(item);
      if (health == "dns_problems") return this.hasDockerDnsProblem(item);
      if (health == "alerts")
        return (
          this.isDockerWithoutBackups(item) ||
          this.hasDockerAccessProblem(item) ||
          this.hasDockerDnsProblem(item)
        );
      return true;
    },
    getDockerGroupHealth(items) {
      var health = {
        withoutBackups: 0,
        accessProblems: 0,
        dnsProblems: 0,
        processing: 0,
      };
      items.forEach((item) => {
        if (this.isDockerWithoutBackups(item)) health.withoutBackups++;
        if (this.hasDockerAccessProblem(item)) health.accessProblems++;
        if (this.hasDockerDnsProblem(item)) health.dnsProblems++;
        if (item.status_process) health.processing++;
      });
      return health;
    },
    getDockerGroupPriority(health) {
      return (
        health.withoutBackups +
        health.accessProblems +
        health.dnsProblems +
        health.processing
      );
    },
    getDockerGroupHealthLabel(health) {
      var alerts = [];
      if (health.withoutBackups)
        alerts.push(health.withoutBackups + " sin backups");
      if (health.accessProblems)
        alerts.push(health.accessProblems + " con problemas de acceso");
      if (health.dnsProblems)
        alerts.push(health.dnsProblems + " con alertas DNS");
      if (health.processing) alerts.push(health.processing + " procesando");
      return alerts.length
        ? "Alertas del grupo: " + alerts.join(", ")
        : "Grupo saludable";
    },
    getDockerDnsLabel(item) {
      if (this.showDnsProxy(item)) return "Proxy Zyncro";
      if (this.showDnsTypeAAAA(item)) return "Registro AAAA";
      if (this.showDnsErrorIp(item)) return "IP no coincide";
      return "Correcto";
    },
    getDockerDnsDetail(item) {
      if (this.showDnsErrorIp(item))
        return "La IP del registro A no coincide con la IP del servidor.";
      if (this.showDnsTypeAAAA(item))
        return "Se detectaron registros AAAA en los DNS.";
      return "No se detectaron alertas DNS.";
    },
    getDockerDnsIcon(item) {
      return this.getDockerDnsLabel(item) == "Correcto"
        ? "check_circle"
        : "warning";
    },
    getDockerDnsTone(item) {
      return this.getDockerDnsLabel(item) == "Correcto"
        ? "text-success"
        : "text-danger";
    },
    configViewerJson() {
      setTimeout(() => {
        var arrElement = document.getElementsByClassName("json-tree-indent");
        if (arrElement) {
          for (var i = 0; i < arrElement.length; i++) {
            if (arrElement[i].innerHTML != "&nbsp;") {
              arrElement[i].innerHTML = "&nbsp;";
            }
          }
        }
      }, 100);
    },
    getAccessInfo(item) {
      if (!item.access) {
        return null;
      }

      try {
        return JSON.parse(item.access);
      } catch (error) {
        return null;
      }
    },
    isDnsDirectIp(item) {
      var access = this.getAccessInfo(item);
      var serverHost = item.server ? item.server.host : "";

      return (
        access &&
        access.dns_get_ip &&
        serverHost &&
        access.dns_get_ip == serverHost
      );
    },
    isDnsCheckZyncro(item) {
      var access = this.getAccessInfo(item);

      return (
        access &&
        (access.dns_check_zyncro === true ||
          access.dns_check_zyncro === 1 ||
          access.dns_check_zyncro === "1" ||
          access.dns_check_zyncro === "true")
      );
    },
    showDnsTypeAAAA(item) {
      var access = this.getAccessInfo(item);

      return access && access.dns_type_aaaa && this.isDnsDirectIp(item);
    },
    showDnsErrorIp(item) {
      var access = this.getAccessInfo(item);
      var serverHost = item.server ? item.server.host : "";

      return (
        access &&
        access.dns_get_ip &&
        serverHost &&
        access.dns_get_ip != serverHost &&
        !this.isDnsCheckZyncro(item)
      );
    },
    showDnsProxy(item) {
      return this.isDnsCheckZyncro(item);
    },
    getDnsProxyTitle(item) {
      var access = this.getAccessInfo(item);

      if (!access) {
        return "";
      }

      var path =
        access.dns_check_zyncro_path || "/backend/public/storage/check-zyncro";
      var url = access.dns_check_zyncro_url || "";
      var content = access.dns_check_zyncro_content || "true";

      return (
        "Proxy Zyncro detectado. Ruta: " +
        path +
        ". URL: " +
        url +
        ". Contenido: " +
        content
      );
    },
    loadFieldTable() {
      this.table.fields.push({
        key: "id",
        label: "ID",
        sortable: true,
        class: "align-middle",
      });

      if (this.parameters.integrateServices) {
        this.table.fields.push({
          key: "services",
          label: "",
          class: "align-middle",
        });
      }

      this.table.fields.push({
        key: "name",
        label: "Nombre",
        class: "align-middle",
      });
      this.table.fields.push({
        key: "customer_id",
        label: "Cliente",
        class: "align-middle",
      });
      this.table.fields.push({
        key: "observations",
        label: "",
        class: "align-middle",
      });
      this.table.fields.push({
        key: "instances_server_id",
        label: "VPS Instalación",
        class: "align-middle",
      });
      this.table.fields.push({
        key: "status_process",
        label: "",
        class: "align-middle text-center",
      });
      this.table.fields.push({
        key: "instances_server_backups_id",
        label: "VPS Backups",
        class: "align-middle",
      });
      this.table.fields.push({
        key: "backups",
        label: "Backups",
        class: "align-middle text-center",
      });
      this.table.fields.push({
        key: "access",
        label: "Accesos",
        class: "align-middle text-center",
      });
      this.table.fields.push({
        key: "dns",
        label: "DNS",
        class: "align-middle text-center",
      });
      this.table.fields.push({
        key: "f_action",
        label: "",
        class: "align-middle text-center",
      });
    },

    // crud
    filter() {
      this.saveFilterStorage();

      this.table.isBusy = true;

      var result = serviceAPI.filtrarSistema(
        this.filters,
        this.table.currentPage
      );

      result
        .then((response) => {
          var data = response.data;
          this.table.tablePaginate = data;

          this.table.items = data.data.filter((item) =>
            this.matchesSelectedHealth(item)
          );
          if (this.filters.health && this.filters.health.code != "all") {
            this.table.tablePaginate.total = this.table.items.length;
            this.table.tablePaginate.last_page = 1;
          }
          this.syncDockerGroupsExpansion(this.table.items);

          if (this.$refs.table) {
            this.$refs.table.$forceUpdate();
          }

          this.table.isBusy = false;
        })
        .catch((error) => {
          this.table.isBusy = false;
          //this.$awn.alert(Error.showError(error))
        });
    },
    add() {
      this.crud.form.id = 0;
      this.crud.form.name = "";
      this.crud.form.customer_id = 0;
      this.crud.form.customer = null;
      this.crud.form.instances_server_id = 0;
      this.crud.form.instances_server = null;
      this.crud.form.instances_server_backups_id = 0;
      this.crud.form.instances_server_backups = null;
      this.crud.form.services_customers_details_id = 0;
      this.crud.form.services_customers_details = null;
      this.crud.form.categories_id = 0;
      this.crud.form.categories = null;
      this.crud.form.observations = "";
      this.crud.form.name_db_backups_others = "";
      this.crud.form.route_folder_backups_others = "";
      this.crud.form.route_folder_backups_docker = "";
      this.crud.form.control_backups = false;
      this.crud.form.observations_backups = "";
      this.crud.form.own = false;
      this.crud.form.type = "docker";

      this.modal.form._id = Math.random().toString(36).slice(2, 8);
      this.modal.form.title = "Nuevo Sistema";
      this.modal.form.active = true;
    },
    edit(item) {
      this.crud.form.id = item.id;
      this.crud.form.name = item.name;
      this.crud.form.customer_id = item.customer.id;
      this.crud.form.customer = item.customer;
      this.crud.form.instances_server_id = item.instances_server_id;
      this.crud.form.instances_server = item.server;
      this.crud.form.instances_server_backups_id =
        item.instances_server_backups_id;
      this.crud.form.instances_server_backups = item.server_backups;
      this.crud.form.services_customers_details_id =
        item.services_customers_details_id;
      this.crud.form.services_customers_details =
        item.services_customers_details;
      this.crud.form.categories_id = item.categories_id;
      this.crud.form.categories = item.categorie;
      this.crud.form.observations = item.observations;
      this.crud.form.name_db_backups_others = item.name_db_backups_others;
      this.crud.form.route_folder_backups_others =
        item.route_folder_backups_others;
      this.crud.form.route_folder_backups_docker =
        item.route_folder_backups_docker;
      this.crud.form.control_backups = item.control_backups;
      this.crud.form.observations_backups = item.observations_backups;
      this.crud.form.own = false;
      this.crud.form.type = "docker";

      this.modal.form._id = Math.random().toString(36).slice(2, 8);
      this.modal.form.title = "Editar Sistema";
      this.modal.form.active = true;
    },
    remove(item) {
      this.crud.form.id = item.id;
      this.crud.form.name = item.name;

      this.confirmDialog(
        "¿Desea borrar el sistema (" +
          this.crud.form.id +
          ") - " +
          this.crud.form.name +
          "?",
        {
          title: "Borrar Sistema",
          icon: "delete",
          danger: true,
          okTitle: "SI",
          cancelTitle: "NO",
        }
      )
        .then((value) => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarSistema(this.crud.form.id);

            result
              .then((response) => {
                this.modal.form.active = false;
                loader.hide();
                this.filter();
                this.$awn.success("Sistema eliminado");
              })
              .catch((error) => {
                loader.hide();
                this.$awn.alert(Error.showError(error));
              });
          }
        })
        .catch((error) => {
          this.$awn.alert(Error.showError(error));
        });
    },
    save() {
      let loader = this.$loading.show();

      if (this.crud.form.id) {
        var result = serviceAPI.editarSistema(this.crud.form);
      } else {
        var result = serviceAPI.agregarSistema(this.crud.form);
      }

      result
        .then((response) => {
          this.modal.form.active = false;
          loader.hide();
          this.filter();
          this.$awn.success("Cambios guardado con éxito");
        })
        .catch((error) => {
          loader.hide();
          this.$awn.alert(Error.showError(error));
        });
    },

    // render
    showConfigurateBackupsActive() {
      var status = true;

      if (!this.selectedSystem.backups) {
        status = false;
      } else {
        if (JSON.parse(this.selectedSystem.backups).status == "Inactivo") {
          status = false;
        }
      }

      return status;
    },

    // SELECT
    loadCustomers(object) {
      if (object) {
        this.crud.form.customer = object;
        this.crud.form.customer_id = object.id;
      } else {
        this.crud.form.customer = null;
        this.crud.form.customer_id = 0;
      }
    },
    loadInstancesServer(object) {
      if (object) {
        this.crud.form.instances_server = object;
        this.crud.form.instances_server_id = object.id;
      } else {
        this.crud.form.instances_server = null;
        this.crud.form.instances_server_id = 0;
      }
    },
    loadInstancesServerBackups(object) {
      if (object) {
        this.crud.form.instances_server_backups = object;
        this.crud.form.instances_server_backups_id = object.id;
      } else {
        this.crud.form.instances_server_backups = null;
        this.crud.form.instances_server_backups_id = 0;
      }
    },
    loadServicesCustomersDetails(object) {
      if (object) {
        this.crud.form.services_customers_details = object;
        this.crud.form.services_customers_details_id = object.id;
      } else {
        this.crud.form.services_customers_details = null;
        this.crud.form.services_customers_details_id = 0;
      }
    },

    // fields server table
    showFieldSystem(item, type) {
      var data = null;
      var obj = null;

      if (type == "backups") {
        obj = JSON.parse(item.backups);

        if (obj && obj.status) {
          data = obj.status;
        }
      }

      if (type == "access") {
        obj = JSON.parse(item.access);

        if (obj && obj.status) {
          data = obj.status;
        }
      }

      return data;
    },

    // filter select
    filterLoadSelects() {
      this.filterLoadCustomers();
      this.filterLoadServers();
      this.filterLoadCategories();
    },
    filterLoadCustomers() {
      var result = serviceAPI.obtenerClientes();
      result.then((response) => {
        var data = response.data;

        let arrActive = [];
        let arrInactive = [];
        data.forEach((element) => {
          if (element.active)
            arrActive.push({ code: element.id, label: element.name });
          else
            arrInactive.push({
              code: element.id,
              label: "[INACTIVO] - " + element.name,
            });
        });
        this.arr.select.customers = arrActive.concat(arrInactive);
      });
    },
    filterLoadServers() {
      var result = serviceAPI.obtenerServidor();
      result.then((response) => {
        var data = response.data;

        data.forEach((element) => {
          if (element.type == "docker" || element.show_docker) {
            this.arr.select.instances_servers.push({
              code: element.id,
              label: element.name,
            });
          }
        });
      });
    },
    filterLoadCategories() {
      var result = serviceAPI.obtenerCategoriesByType(this.filterType);
      result.then((response) => {
        var data = response.data;
        data.forEach((element) => {
          this.arr.select.categories.push({
            code: element.id,
            label: element.name,
          });
        });
      });
    },

    // select categories
    loadInstancesCategories(object) {
      if (object) {
        this.crud.form.categories = object;
        this.crud.form.categories_id = object.id;
      } else {
        this.crud.form.categories = null;
        this.crud.form.categories_id = 0;
      }
    },

    // action
    actionSystem(item) {
      this.selectedServer = item.server;
      this.selectedSystem = item;

      this.SSHConsole = "";

      this.modal.command._id = Math.random().toString(36).slice(2, 8);
      this.modal.command.title = "Comandos Sistema: [" + item.name + "]";
      this.modal.command.subtitle = "Terminal";

      this.modal.command.active = true;
    },
    closeActionSystem() {
      this.modal.command.active = false;
      this.filter();
    },
    copySSHConsole() {
      var consoleElement = this.$refs.sshConsole;
      var output = consoleElement
        ? consoleElement.innerText || consoleElement.textContent || ""
        : "";
      if (!output) {
        this.$awn.alert("No hay salida para copiar");
        return;
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(output)
          .then(() => this.$awn.success("Salida copiada al portapapeles"))
          .catch(() => this.copySSHConsoleFallback(output));
        return;
      }

      this.copySSHConsoleFallback(output);
    },
    copySSHConsoleFallback(output) {
      var textarea = document.createElement("textarea");
      textarea.value = output;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      var copied = document.execCommand("copy");
      textarea.remove();
      copied
        ? this.$awn.success("Salida copiada al portapapeles")
        : this.$awn.alert("No se pudo copiar la salida");
    },
    refreshSystem() {
      var result = serviceAPI.mostrarSistema(this.selectedSystem.id);

      result.then((response) => {
        var data = response.data;

        this.selectedSystem = data;

        this.$awn.success("Sistema refrescado");
      });
    },

    getActionSystem(reference, titulo) {
      // titulo de referencia
      this.modal.command.subtitle = titulo;

      // si apunta un dominio para el sistema, lo maneja otro evento
      if (reference == "system-others-domain") {
        this.domainSystem(reference);
        return false;
      }

      // si configura el backups, lo maneja otro evento
      if (reference == "system-others-backups-configurate") {
        this.backupsConfigurateSystem(reference);
        return false;
      }

      // si borro el backups, lo maneja otro evento
      if (reference == "system-others-backups-delete") {
        this.backupsDeleteSystem(reference);
        return false;
      }

      // comandos
      var item = null;

      if (!this.selectedServer) {
        this.$awn.alert("No se encontró el servidor");
        return false;
      }

      if (!this.selectedSystem) {
        this.$awn.alert("No se encontró el sistema");
        return false;
      } else {
        item = this.selectedSystem;
      }

      this.SSHLoader = true;
      var result = serviceAPI.commandActionSistema({
        id: this.selectedServer.id,
        command: reference,
        reference: this.selectedSystem.name,
        domain: this.selectedServer.subdomain,
        system_id: this.selectedSystem.id,
      });

      result
        .then((response) => {
          var data = response.data;

          this.SSHConsole = data;
          this.filter();
          this.SSHLoader = false;
        })
        .catch((error) => {
          this.SSHLoader = false;
          this.$awn.alert(Error.showError(error));
        });
    },

    backupsConfigurateSystem(reference) {
      var item = null;

      if (!this.selectedServer) {
        this.$awn.alert("No se encontró el servidor");
        return false;
      }

      if (!this.selectedSystem) {
        this.$awn.alert("No se encontró el sistema");
        return false;
      } else {
        item = this.selectedSystem;
      }

      this.confirmDialog(
        "¿Desea configurar el backups para el sistema (" + item.name + ")?",
        {
          title: "Configurar Backups",
          okTitle: "SI",
          cancelTitle: "NO",
        }
      )
        .then((value) => {
          if (value) {
            this.SSHLoader = true;
            var result = serviceAPI.commandActionSistema({
              id: this.selectedServer.id,
              command: reference,
              reference: this.selectedSystem.name,
              domain: this.selectedServer.subdomain,
              system_id: this.selectedSystem.id,
            });

            result
              .then((response) => {
                var data = response.data;

                this.SSHConsole = data;
                this.filter();
                this.SSHLoader = false;
              })
              .catch((error) => {
                this.SSHConsole = "Problemas en configurar el backups";
                this.SSHLoader = false;
                this.$awn.alert(Error.showError(error));
              });
          }
        })
        .catch((error) => {
          this.$awn.alert(Error.showError(error));
        });
    },
    backupsDeleteSystem(reference) {
      var item = null;

      if (!this.selectedServer) {
        this.$awn.alert("No se encontró el servidor");
        return false;
      }

      if (!this.selectedSystem) {
        this.$awn.alert("No se encontró el sistema");
        return false;
      } else {
        item = this.selectedSystem;
      }

      this.confirmDialog(
        "¿Desea quitar el backups para el sistema (" + item.name + ")?",
        {
          title: "Quitar Backups",
          icon: "delete",
          danger: true,
          okTitle: "SI",
          cancelTitle: "NO",
        }
      )
        .then((value) => {
          if (value) {
            this.SSHLoader = true;
            var result = serviceAPI.commandActionSistema({
              id: this.selectedServer.id,
              command: reference,
              reference: this.selectedSystem.name,
              domain: this.selectedServer.subdomain,
              system_id: this.selectedSystem.id,
            });

            result
              .then((response) => {
                var data = response.data;

                this.SSHConsole = data;
                this.filter();
                this.SSHLoader = false;
              })
              .catch((error) => {
                this.SSHConsole = "Problemas en quitar el backups";
                this.SSHLoader = false;
                this.$awn.alert(Error.showError(error));
              });
          }
        })
        .catch((error) => {
          this.$awn.alert(Error.showError(error));
        });
    },
    domainSystem() {
      this.crud.formSystem.id = this.selectedSystem.id;
      this.crud.formSystem.domain = this.selectedSystem.domain;

      if (this.selectedSystem.domain) this.modal.formSystem.showCheck = false;
      else this.modal.formSystem.showCheck = true;

      this.modal.formSystem.title =
        "Apuntar Dominio a Sistema: [" + this.selectedSystem.name + "]";
      this.modal.formSystem.active = true;
    },
    saveDomain() {
      this.modal.formSystem.active = false;

      // comandos
      var reference = "system-others-domain";
      var newDomain = this.crud.formSystem;

      if (!this.selectedServer) {
        this.$awn.alert("No se encontró el servidor");
        return false;
      }

      this.SSHLoader = true;
      var result = serviceAPI.commandActionSistema({
        id: this.selectedServer.id,
        command: reference,
        reference: this.selectedSystem.name,
        domain: this.selectedServer.subdomain,
        system_id: this.selectedSystem.id,
        newDomain: newDomain,
      });

      result
        .then((response) => {
          var data = response.data;

          this.SSHConsole = data;
          this.filter();
          this.SSHLoader = false;
        })
        .catch((error) => {
          this.SSHLoader = false;
          this.$awn.alert(Error.showError(error));
        });
    },

    // FILTROS SAVE
    saveFilterStorage() {
      Storage.setValue(
        "filter_view_instances_system_docker",
        JSON.stringify(this.filters)
      );
    },
    restoreFilterStorage() {
      if (Storage.getValue("filter_view_instances_system_docker")) {
        this.filters = JSON.parse(
          Storage.getValue("filter_view_instances_system_docker")
        );
      }
      if (!this.filters.health) {
        this.filters.health = { code: "all", label: "Todos" };
      }
    },
  },
};
</script>
<style>
.ssh-console-system {
  background-color: black;
  background-image: radial-gradient(rgba(0, 150, 0, 0.75), black 120%);
  height: 175px;
  color: white;
  font: 13px Inconsolata, monospace;
  text-shadow: 0 0 5px #c8c8c8;
  padding: 10px;
  white-space: pre;
  overflow: auto;
}
.ssh-console-system::after {
  content: "";
  /*position: absolute;*/
  top: 0;
  left: 0;
  width: 100vw;
  height: 175px;
  background: repeating-linear-gradient(
    0deg,
    rgba(black, 0.15),
    rgba(black, 0.15) 1px,
    transparent 1px,
    transparent 2px
  );
  padding: 10px;
}
.ssh-console-system::selection {
  background: #0080ff;
  text-shadow: none;
}
.ssh-console-footer {
  z-index: 9999;
}
.app-command-terminal-column {
  display: flex;
}
.app-command-terminal {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.app-command-terminal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 36px;
  margin-bottom: 8px;
}
.app-command-terminal__header h4 {
  margin: 0;
  color: var(--app-color-text);
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
}
.app-command-terminal__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 28px;
}
.app-command-terminal__process {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--app-color-primary);
  font-size: 12px;
  font-weight: 600;
}
.btn.app-command-terminal__copy {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
}
.btn.app-command-terminal__refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 28px;
  padding: 0;
  border-radius: 4px;
}
.app-command-terminal__loader {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 175px;
  background: #071009;
}
.ssh-console-system {
  flex: 0 0 420px;
  box-sizing: border-box;
  height: 420px !important;
  max-height: calc(100vh - 220px);
  padding: 10px;
  overflow-x: auto;
  overflow-y: auto !important;
  border-radius: 0;
  background-color: #071009;
  background-image: radial-gradient(
    ellipse at center,
    #173b1a 0%,
    #0b1d0e 52%,
    #071009 100%
  );
  color: #fff;
  font: 13px Inconsolata, monospace;
  line-height: 1.45;
  overflow-wrap: anywhere;
  text-shadow: none;
}
.ssh-console-system::after {
  display: none;
}
@media (max-width: 767.98px) {
  .app-command-terminal__header {
    align-items: flex-start;
  }
  .app-command-terminal__header h4 {
    font-size: 18px;
  }
  .ssh-console-system {
    flex-basis: 320px;
    height: 320px !important;
    max-height: calc(100vh - 190px);
  }
}
.instance-system-divide {
  margin-top: 1px;
  margin-bottom: 10px;
}
.instances-docker-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 240px;
  color: var(--app-color-text-secondary);
  font-size: 13px;
}
.instances-docker-groups {
  display: grid;
  gap: 16px;
  padding: 12px;
}
.instances-docker-group-card {
  overflow: hidden;
  border-color: var(--app-color-border);
  border-radius: 10px;
  box-shadow: var(--app-shadow-sm);
}
.instances-docker-group-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  border-bottom: 1px solid var(--app-color-border);
  background: var(--app-color-surface-subtle);
  color: var(--app-color-text);
  text-align: left;
}
.instances-docker-group-card__header:hover {
  background: var(--app-color-primary-soft);
}
.instances-docker-group-card__header--static {
  cursor: default;
}
.instances-docker-group-card__header--static:hover {
  background: var(--app-color-surface-subtle);
}
.instances-docker-group-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
}
.instances-docker-group-card__summary h3,
.instances-docker-card__title h4 {
  margin: 0;
  color: var(--app-color-text);
}
.instances-docker-group-card__summary h3 {
  font-size: 14px;
  line-height: 1.15;
}
.instances-docker-group-card__summary span,
.instances-docker-card__id,
.instances-docker-card__meta,
.instances-docker-card__alert span {
  color: var(--app-color-text-secondary);
  font-size: 11px;
}
.instances-docker-group-card__health {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-left: auto;
}
.instances-docker-group-card__health-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 7px;
  border: 1px solid;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
}
.instances-docker-group-card__health-item--success {
  border-color: var(--app-color-success-border);
  background: var(--app-color-success-soft);
  color: var(--app-color-success-hover);
}
.instances-docker-group-card__health-item--warning {
  border-color: var(--app-color-warning-border);
  background: var(--app-color-warning-soft);
  color: var(--app-color-warning-hover);
}
.instances-docker-group-card__health-item--danger {
  border-color: var(--app-color-danger-border);
  background: var(--app-color-danger-soft);
  color: var(--app-color-danger-hover);
}
.instances-docker-group-card__health-item--info {
  border-color: var(--app-color-primary-200);
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
}
.instances-docker-group-card__toggle {
  margin-left: auto;
  color: var(--app-color-text-secondary);
}
.instances-docker-group-card__body {
  padding: 10px;
  background: var(--app-color-canvas);
}
.instances-docker-group-card__cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 10px;
}
.instances-docker-view-switcher {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  margin-right: 7px;
  padding-right: 7px;
  border-right: 1px solid var(--app-color-border);
}
.instances-docker-view-switcher
  .btn.list-view-icon-btn.list-view-icon-btn--active {
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
}
.instances-docker-tree-view {
  display: grid;
  gap: 2px;
}
.instances-docker-tree-view__system {
  display: grid;
  grid-template-columns: 32px minmax(190px, 0.8fr) minmax(0, 2.2fr);
  align-items: center;
  min-height: 46px;
  border-bottom: 1px solid var(--app-color-border);
  background: var(--app-color-surface);
}
.instances-docker-tree-view__system:last-child {
  border-bottom: 0;
}
.instances-docker-tree-view__branch {
  display: inline-flex;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  color: var(--app-color-primary);
}
.instances-docker-tree-view__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  padding: 7px 8px 7px 0;
}
.instances-docker-tree-view__details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 7px 12px;
}
.instances-docker-tree-view__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}
.instances-docker-tree-view__item .material-symbols-outlined {
  font-size: 17px;
}
.instances-docker-tree-view__item b {
  color: var(--app-color-text-secondary);
  font-weight: 600;
}
.instances-docker-tree-view__item.text-danger {
  padding: 3px 6px;
  border: 1px solid var(--app-color-danger-border);
  border-radius: 4px;
  background: var(--app-color-danger-soft);
  color: var(--app-color-danger-hover);
}
.instances-docker-tree-view__item.text-danger b {
  color: inherit;
}
.instances-docker-tree-view__link,
.instances-docker-tree-view__more {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  white-space: nowrap;
}
.instances-docker-tree-view__more {
  cursor: pointer;
  color: var(--app-color-primary);
}
.instances-docker-tree-view__more .material-symbols-outlined {
  font-size: 18px;
}
.instances-docker-tree-view__header > .instances-docker-card__title {
  flex: 1 1 0;
  min-width: 0;
  flex-wrap: wrap;
}
.instances-docker-tree-view__header h4 {
  min-width: 0;
  overflow-wrap: anywhere;
}
.instances-docker-tree-view__link {
  max-width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}
.instances-docker-tree-view__header > .btn-group,
.instances-docker-tree-view__header > .dropdown {
  flex: 0 0 auto;
}
.instances-docker-card {
  padding: 12px;
  border: 1px solid var(--app-color-border);
  border-radius: 8px;
  background: var(--app-color-surface);
  box-shadow: var(--app-shadow-sm);
}
.instances-docker-card__heading {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.instances-docker-card__title,
.instances-docker-card__meta,
.instances-docker-card__infrastructure,
.instances-docker-card__links,
.instances-docker-card__alert {
  display: flex;
  align-items: center;
  gap: 7px;
}
.instances-docker-card__title h4 {
  font-size: 17px;
}
.instances-docker-card__meta,
.instances-docker-card__infrastructure,
.instances-docker-card__links {
  flex-wrap: wrap;
  margin-top: 6px;
  font-size: 12px;
}
.instances-docker-card__server {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 6px;
  border: 1px solid var(--app-color-border);
  border-radius: 999px;
  background: var(--app-color-surface);
  color: var(--app-color-text-secondary);
  font-size: 11px;
  font-weight: 600;
}
.instances-docker-card__links {
  margin-top: 12px;
}
.instances-docker-card__links a {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.instances-docker-card__metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--app-color-border);
}
.instances-docker-card__section {
  display: grid;
  align-content: start;
  justify-items: center;
  gap: 7px;
  min-width: 0;
}
.instances-docker-card__section--controls {
  grid-column: 1 / -1;
}
.instances-docker-card__section-label {
  color: var(--app-color-text-secondary);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.instances-docker-checks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 7px;
}
.instances-docker-check {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  min-width: 52px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.1;
  text-align: center;
}
.instances-docker-check small {
  color: var(--app-color-text-secondary);
  font-size: 10px;
  font-weight: 400;
}
.instances-docker-card__alerts {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}
.instances-docker-card__alert {
  align-items: flex-start;
  padding: 8px 10px;
  border: 1px solid var(--app-color-border);
  border-left: 4px solid var(--app-color-primary);
  border-radius: 4px;
}
.instances-docker-card__alert--backup {
  border-left-color: var(--app-color-warning);
}
.instances-docker-card__alert div {
  display: grid;
  gap: 2px;
  min-width: 0;
}
.instances-docker-card__alert b {
  font-size: 12px;
}
.instances-docker-card__alert span {
  line-height: 1.35;
}
.instances-docker-command-panel-column {
  display: flex;
}
.instances-docker-command-panel {
  width: 100%;
  max-height: 450px;
  padding: 10px;
  overflow-y: auto;
  border: 1px solid var(--app-color-border);
  border-radius: 8px;
  background: var(--app-color-surface-subtle);
}
.instances-docker-command-panel h6 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 4px 9px;
  color: var(--app-color-text-secondary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.instances-docker-command-group {
  border-top: 1px solid var(--app-color-border);
}
.instances-docker-command-group:last-child {
  border-bottom: 1px solid var(--app-color-border);
}
.btn.instances-docker-command-group__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 36px;
  padding: 7px 4px;
  color: var(--app-color-text);
  font-size: 13px;
  font-weight: 700;
  text-align: left;
}
.instances-docker-command-group__toggle > span,
.btn.instances-docker-command-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.instances-docker-command-group__toggle:hover,
.instances-docker-command-group__toggle:focus {
  color: var(--app-color-primary);
  text-decoration: none;
}
.instances-docker-command-group__actions {
  display: grid;
  gap: 2px;
  padding: 0 0 8px;
}
.instances-docker-command-subsection {
  display: block;
  margin: 8px 0 3px;
  padding: 5px 7px;
  border-top: 1px solid var(--app-color-border);
  border-left: 3px solid var(--app-color-primary);
  background: var(--app-color-surface-muted);
  color: var(--app-color-text-secondary);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.instances-docker-command-subsection:first-child {
  margin-top: 1px;
}
.btn.instances-docker-command-action {
  min-height: 31px;
  padding: 5px 7px;
  color: var(--app-color-text-secondary);
  font-size: 12px;
  text-align: left;
}
.btn.instances-docker-command-action:hover,
.btn.instances-docker-command-action:focus {
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
  text-decoration: none;
}
.btn.instances-docker-command-action--danger:hover,
.btn.instances-docker-command-action--danger:focus {
  background: var(--app-color-danger-soft);
  color: var(--app-color-danger-hover);
}
@media (max-width: 767.98px) {
  .instances-docker-groups {
    padding: 8px;
  }
  .instances-docker-group-card__body {
    padding: 8px;
  }
  .instances-docker-group-card__cards {
    grid-template-columns: 1fr;
  }
  .instances-docker-tree-view__system {
    grid-template-columns: 27px minmax(0, 1fr);
  }
  .instances-docker-tree-view__details {
    grid-column: 2;
    padding: 0 8px 9px 0;
    gap: 8px;
  }
  .instances-docker-card {
    padding: 13px;
  }
  .instances-docker-card__metrics {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .instances-docker-card__section {
    justify-items: start;
  }
  .instances-docker-checks {
    justify-content: flex-start;
  }
  .instances-docker-group-card__header {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .instances-docker-group-card__health {
    order: 3;
    flex-basis: calc(100% - 34px);
    justify-content: flex-start;
    margin-left: 34px;
  }
  .instances-docker-command-panel-column {
    margin-bottom: 12px;
  }
}
</style>
<style scoped>
.b-avatar {
  width: 25px;
  height: 25px;
}
</style>
